import React from "react";
import { ContentPage, Prose } from "../../components/ContentPage";
import { BRAND } from "../../data/site";

export default function Polityka() {
  return (
    <ContentPage
      testid="page-polityka"
      eyebrow="Dokumenty"
      title="Polityka prywatności"
      lead="Dbamy o Twoją prywatność i bezpieczeństwo danych. Poniżej wyjaśniamy, jakie dane zbieramy i w jaki sposób je przetwarzamy."
      seo={{
        title: "Polityka prywatności | PMPOINT",
        description: "Polityka prywatności PMPOINT SP. Z O.O. — zasady przetwarzania danych osobowych zgodnie z RODO, cele, podstawy prawne i prawa użytkownika.",
        canonical: "https://pmpoint.pl/polityka-prywatnosci",
      }}
    >
      <Prose>
        <p><strong>Administrator danych:</strong> {BRAND.legalName}, {BRAND.address}, NIP {BRAND.nip}. Kontakt: {BRAND.email}, tel. {BRAND.phone}.</p>

        <h2>1. Jakie dane zbieramy</h2>
        <p>Za pośrednictwem formularza zgłoszeniowego zbieramy dane, które podajesz dobrowolnie: imię, wiek, miasto/kraj, dane kontaktowe (np. Telegram/Instagram), informacje o doświadczeniu oraz treść wiadomości. Automatycznie możemy zbierać dane statystyczne o korzystaniu ze strony (np. za pomocą Google Analytics).</p>

        <h2>2. Cele i podstawy przetwarzania</h2>
        <ul>
          <li>Kontakt i obsługa zgłoszenia rekrutacyjnego (art. 6 ust. 1 lit. b i f RODO).</li>
          <li>Prowadzenie rozmów w sprawie współpracy i zawarcie umowy.</li>
          <li>Analityka i poprawa działania strony (uzasadniony interes administratora).</li>
        </ul>

        <h2>3. Okres przechowywania</h2>
        <p>Dane przechowujemy przez czas niezbędny do obsługi zgłoszenia i współpracy, a następnie przez okres wynikający z przepisów prawa lub do czasu wniesienia sprzeciwu.</p>

        <h2>4. Odbiorcy danych</h2>
        <p>Dane mogą być powierzane zaufanym podmiotom przetwarzającym (np. dostawcy hostingu, poczty i narzędzi analitycznych) wyłącznie w zakresie niezbędnym do świadczenia usług.</p>

        <h2>5. Twoje prawa</h2>
        <ul>
          <li>Prawo dostępu do danych oraz otrzymania ich kopii.</li>
          <li>Prawo do sprostowania, usunięcia lub ograniczenia przetwarzania.</li>
          <li>Prawo do sprzeciwu oraz przenoszenia danych.</li>
          <li>Prawo wniesienia skargi do Prezesa UODO.</li>
        </ul>

        <h2>6. Pliki cookies i analityka</h2>
        <p>Strona może wykorzystywać pliki cookies oraz narzędzia analityczne (Google Analytics) w celach statystycznych. Możesz zarządzać cookies w ustawieniach swojej przeglądarki.</p>

        <h2>7. Wiek</h2>
        <p>Współpracujemy wyłącznie z osobami pełnoletnimi (18+). Wypełniając formularz, potwierdzasz ukończenie 18 lat.</p>

        <h2>8. Kontakt</h2>
        <p>W sprawach dotyczących danych osobowych napisz na: <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a>.</p>

        <p className="text-sm text-white/40">Dokument ma charakter informacyjny. Zalecamy konsultację treści z prawnikiem i dostosowanie do rzeczywistych procesów przetwarzania danych.</p>
      </Prose>
    </ContentPage>
  );
}
